@app.directive 'matrixItemListForm', (AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @setItem = (selectedItem, currentItem)->
      console.log 'setting item'
      angular.forEach currentItem.content, (value, key) ->
        if selectedItem.hasOwnProperty(key)
          currentItem.content[key] = selectedItem[key]
    this
  controllerAs: 'matrixItemListForm'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemList/matrixItemListForm.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    source: '@'
  }
